/** @jsxImportSource @emotion/react */
import React from 'react'
import css from '@emotion/css/macro'
import { getImageThumbnailId } from '@sportninja/common/reducers/helpers'

interface GameListTeamLogoProps {
  team: any
  className?: string
  style?: React.CSSProperties
}

const GameListTeamLogo: React.FC<GameListTeamLogoProps> = ({
  team,
  className,
  style,
}) => {
  const imageSrc =
    getImageThumbnailId(team) ||
    '/images/generic_placeholders/placeholder_team.png'

  return (
    <div
      className={className}
      css={css`
        display: flex;
        justify-content: center;
        align-items: center;
        width: 64px;
        height: 64px;
        overflow: hidden;
        border-radius: 8px;
      `}
      style={style}
    >
      <img
        src={imageSrc}
        alt={team?.name_full || 'Team Logo'}
        css={css`
          width: 100%;
          height: 100%;
          object-fit: contain;
        `}
      />
    </div>
  )
}

export default GameListTeamLogo
